var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "split-pane",
        [
          _vm.defer(3)
            ? _c("events-history", { attrs: { slot: "left" }, slot: "left" })
            : _vm._e(),
          _c("event-inspector", { attrs: { slot: "right" }, slot: "right" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }